import linkUtils from '../../linkUtils';
import BookLocation from 'types/BookLocation';

/**
 * @method getLocationForInternalLink
 * @param  currentDocument - current active document
 * @param {String} internalLink - href string from book content
 */
const getLocationForInternalLink = (currentDocument, internalLink) => {
  let document = currentDocument;

  if (internalLink && !linkUtils.isDataUri(internalLink)) {
    if (linkUtils.isExternalLink(internalLink)) {
      window.open(internalLink, '_blank');
      return;
    }

    if (linkUtils.isInternalHashtag(internalLink)) {
      return new BookLocation({
        document,
        element: internalLink.split('#')[1],
      });
    }

    if (linkUtils.isInternalLinkById(internalLink)) {
      // split from ?#sp(id)#(element) to [id, element]
      const { spineId, fragmentId } =
        linkUtils.parseInternalLinkById(internalLink);
      if (spineId) {
        document = currentDocument.book.documents.find(
          (document) => `${document.pk}` === `${spineId}`,
        );

        if (!document) {
          return null;
        }

        return new BookLocation({
          document,
          element: fragmentId ?? undefined,
        });
      }
    }

    if (linkUtils.isInternalLinkByPlayOrder(internalLink)) {
      const { spinePlayOrder, fragmentId } =
        linkUtils.parseInternalLinkByPlayOrder(internalLink);
      if (spinePlayOrder) {
        document = currentDocument.book.documents[spinePlayOrder];

        if (!document) {
          return null;
        }

        return new BookLocation({
          document,
          element: fragmentId ?? undefined,
        });
      }
    }
  }

  return null;
};

export default getLocationForInternalLink;
